<template>
  <div>
    <section class="clearfix cover">
      <p>
        <img
          :src="require('../assets/images/about.jpg')"
          alt="About Climate Innovation Center Gahana"
        />
      </p>
    </section>
    <!-- About area -->
    <section class="about-area">
      <div class="container container-xs">
        <div class="row">
          <main class="col-lg-12 mb-5">
            <h1 class="page-title">About this directory</h1>
            <p>
              The GCIC Investor Directory is the most comprehensive,
              continuously updated source of information on investors funding
              Green Economy startups in Ghana. The data in the directory is
              compiled from several sources, including publicly-available
              information, news reports, self-reported information, and the
              AlliedCrowds database.
            </p>
            <p>
              The directory was built for GCIC by AlliedCrowds. The funding for
              this database was provided by the World Bank. Do you have a
              question about the directory or the information in it? Please
              contact us here.
            </p>
            <p class="my-5 py-lg-5">
              <router-link :to="{ name: 'Index' }" class="back-link">
                <i class="fa fa-angle-left text-success" aria-hidden="true"></i>
                Back to directory
              </router-link>
            </p>
          </main>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "About"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/About.vue